/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/* jshint ignore:start */
/**
 * Calculate reachable range implementation using using the TomTom's Reachable Range API.
 *
 * Allows to make route request using the TomTom's [Calculate Reachable Range API Documentation](https://developer.tomtom.com/online-routing/online-routing-documentation-routing/calculate-reachable-range).
 *
 * The Calculate Reachable Range service calculates a set of locations that can
 * be reached from the origin point, subject to the available fuel or energy
 * budget that is specified in the request.
 *
 * The information returned is a polygon boundary in counterclockwise orientation
 * and the precise polygon center (the result of map-matching the origin point).
 *
 * @class ReachableRange
 * @module Services
 * @uses KeyMixin
 * @uses Chain
 * @uses CommonRoutingParameters
 * @uses ProtocolMixin
 * @constructor
 *
 * @param {Object} [options] Options to be passed to the routing call,
 *     or Array of such options objects to perform batch request.
 * @param {String} [options.key=global API key] The API key to be used.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 * @param {Number} [options.accelerationEfficiency] Specifies the efficiency of converting chemical energy stored in
 * fuel to kinetic energy when the vehicle accelerates (i.e. KineticEnergyGained/ChemicalEnergyConsumed).
 * @param {String} [options.arriveAt] The date and time of arrival at the destination point.
 * @param {Number} [options.auxiliaryPowerInkW] Specifies the amount of power consumed for sustaining auxiliary systems, in kilowatts (kW).
 * @param {Number} [options.auxiliaryPowerInLitersPerHour] Specifies the amount of fuel consumed for sustaining
 * auxiliary systems of the vehicle, in liters per hour. It can be used to specify consumption due to devices
 * and systems such as AC systems, radio, heating, etc.
 * @param {Array|String} [options.avoid] Specifies something that the route calculation should try to avoid when
 * determining the route.
 * @param {Array} [options.constantSpeedConsumptionInLitersPerHundredkm] Colon-delimited list of
 * CombustionConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
 * @param {Array} [options.constantSpeedConsumptionInkWhPerHundredkm] Colon-delimited list of
 * ElectricConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
 * @param {Number} [options.currentChargeInkWh] Specifies the current electric energy supply in kilowatt hours (kWh).
 * @param {Number} [options.currentFuelInLiters] Current supply of fuel in liters.
 * @param {Number} [options.decelerationEfficiency] Specifies the efficiency of converting kinetic energy to saved
 * (not consumed) fuel when the vehicle decelerates (i.e. ChemicalEnergySaved/KineticEnergyLost).
 * @param {String} [options.departAt] The date and time of departure from the origin point
 *     response.
 * @param {Number} [options.downhillEfficiency] Specifies the efficiency of converting potential energy to
 * saved (not consumed) fuel when the vehicle loses elevation (i.e. ChemicalEnergySaved/PotentialEnergyLost).
 * @param {Number} [options.energyBudgetInkWh] Electric energy budget in kilowatt
 *     hours (kWh) that determines maximal range which can be travelled using the
 *     specified Electric Consumption Model. Required if vehicleEngineType is
 *     electric.
 * @param {Number} [options.fuelBudgetInLiters] Fuel budget in liters that determines
 *     maximal range which can be travelled using the specified Combustion
 *     Consumption Model. Required if vehicleEngineType is combustion.
 * @param {Number} [options.fuelEnergyDensityInMJoulesPerLiter] Specifies the amount of chemical energy stored
 * in one liter of fuel in megajoules (MJ). It is used in conjunction with the Efficiency parameters for
 * conversions between saved or consumed energy and fuel.
 * @param {String} [options.hilliness] Degree of hilliness for thrilling route.
 * @param {Number} [options.maxChargeInkWh] Specifies the maximum electric energy supply in kilowatt hours (kWh)
 * that may be stored in the vehicle's battery.
 * @param {Array|String} [options.origin] Point from which the range calculation should start.
 * @param {String} [options.protocol] Protocol's type, one of "http" or "https".
 * @param {String} [options.report] Specifies which data should be reported for diagnosis purposes. Possible values:
 * * effectiveSettings reports the effective parameters or data used when calling the API. In the case of defaulted
 * parameters the default will be reflected where the parameter was not specified by the caller.
 * @param {String} [options.routeType] The type of route requested.
 * @param {String} [options.traffic] consider all available traffic information during routing
 *     determining the route.
 * @param {Number} [options.timeBudgetInSec] Time budget in seconds that determines maximal
 * range which can be travelled using driving time.
 * @param {String} [options.travelMode] The mode of travel for the requested route.
 * @param {Number} [options.uphillEfficiency] Specifies the efficiency of converting chemical energy stored in
 * fuel to potential energy when the vehicle gains elevation (i.e. PotentialEnergyGained/ChemicalEnergyConsumed).
 * @param {Number} [options.vehicleAxleWeight] The vehicle axle weight in kg.
 * @param {Boolean} [options.vehicleCommercial] True if vehicle is used for commercial purposes.
 * @param {String} [options.vehicleEngineType] The vehicle engine type.
 * @param {Number} [options.vehicleHeight] The vehicle height in m.
 * @param {Number} [options.vehicleLength] The vehicle length in meters.
 * @param {Array|String} [options.vehicleLoadType] The array of truck cargo classification.
 * @param {Number} [options.vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
 * @param {Number} [options.vehicleWeight] The vehicle weight in kg.
 * @param {Number} [options.vehicleWidth] The vehicle width in m.
 * @param {String} [options.windingness] Level of turns for thrilling route.
 *
 * @example
 * ```javascript
 *     tomtom.reachableRange({
 *         origin: '51.776667,19.454722',
 *         fuelBudgetInLiters: 5,
 *         constantSpeedConsumptionInLitersPerHundredkm: ["10,20", "15,30"],
 *     })
 *         .go()
 *         .then(function(rangeData) {
 *             console.log(L.geoJson(rangeData));
 *         })
 *         .catch(function(error) {
 *             console.error(error);
 *         });
 * ```
 */
/* eslint-enable max-len */
/* jshint ignore:end */

define([
    'rest/routing/routing',
    'model/routing/reachableRange',
    'model/routing/batchReachableRange',
    '../chain',
    '../validators',
    '../converters',
    './reachableRangeParameters'
], function(
    routing,
    reachableRange,
    batchReachableRangeModel,
    chain,
    validators,
    converters,
    reachableRangeParameters
) {
    var batchFields;

    var fields = reachableRangeParameters();

    batchFields = {
        batchItems: {
            validator: validators.arrayOf(fields),
            converter: converters.arrayOf(fields)
        }
    };

    function handleChain(data, callback) {
        routing.calculateReachableRange(data, function(response) {
            callback.call(this, reachableRange(response, data));
        });
    }

    function handleBatchChain(data, callback) {
        routing.batchReachableRange(data, function(response) {
            callback.call(this, batchReachableRangeModel(response));
        });
    }

    return function(options) {
        if (Array.isArray(options)) {
            return chain(batchFields, handleBatchChain, {
                batchItems: options
            });
        }
        return chain(fields, handleChain, options);
    };

});



// WEBPACK FOOTER //
// ./services/routing/reachableRange.js